import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import _10x81 from "./10x81.png";
import _10x82 from "./10x82.png";
import _10x83 from "./10x83.png";

const width = "70";
const height = "auto";
const viewBox = "0 0 320 194";

const getDimensions = (size, sizes) => {
  if (size && typeof size.width === 'number' && typeof size.height === 'number') {
    return size
  }
  return size && sizes[size]
    ? sizes[size]
    : { width, height }
}

const getCss = (size, sizes, fillColor, fillColorRule, noStyles) => {
  if (noStyles) { return '' }
  const dimensions = getDimensions(size, sizes)
  const fillRule = fillColor && fillColorRule ? `${fillColorRule}{ fill: ${fillColor}; }` : ''
  return css`
    width: ${dimensions.width}%;
    height: ${dimensions.height};
    ${fillRule}
  `
}

const propsToCss = ({
  size,
  sizes,
  fillColor,
  fillColorRule,
  noStyles
}) => getCss(size, sizes, fillColor, fillColorRule, noStyles)

const Image = styled.svg`${propsToCss}`

const children = (
  <Fragment>
    <defs
      key='key-0'
    >
      <linearGradient
        id='s-3ed5450257-a'
        x1='-2628.78'
        x2='-2628.53'
        y1='348.78'
        y2='348.78'
        gradientTransform='matrix(-1 0 0 1 -2475.59 -276.72)'
        gradientUnits='userSpaceOnUse'
      >
        <stop
          offset='0'
          stopColor='#595959'
        />
        <stop
          offset='.5'
          stopColor='#949494'
        />
        <stop
          offset='1'
          stopColor='#5c5c5c'
        />
      </linearGradient>
      <linearGradient
        id='s-3ed5450257-d'
        x1='-2627.6'
        x2='-2627.35'
        y1='348.72'
        y2='348.72'
        xlinkHref='#s-3ed5450257-a'
      />
      <linearGradient
        id='s-3ed5450257-e'
        x1='-2626.48'
        x2='-2626.23'
        y1='348.66'
        y2='348.66'
        xlinkHref='#s-3ed5450257-a'
      />
      <linearGradient
        id='s-3ed5450257-f'
        x1='-2625.37'
        x2='-2625.12'
        y1='348.58'
        y2='348.58'
        xlinkHref='#s-3ed5450257-a'
      />
      <linearGradient
        id='s-3ed5450257-g'
        x1='-2624.19'
        x2='-2623.94'
        y1='348.51'
        y2='348.51'
        xlinkHref='#s-3ed5450257-a'
      />
      <linearGradient
        id='s-3ed5450257-h'
        x1='-2623.07'
        x2='-2622.82'
        y1='348.45'
        y2='348.45'
        xlinkHref='#s-3ed5450257-a'
      />
      <linearGradient
        id='s-3ed5450257-i'
        x1='-2621.95'
        x2='-2621.7'
        y1='348.38'
        y2='348.38'
        xlinkHref='#s-3ed5450257-a'
      />
      <linearGradient
        id='s-3ed5450257-j'
        x1='-2620.76'
        x2='-2620.51'
        y1='348.31'
        y2='348.31'
        xlinkHref='#s-3ed5450257-a'
      />
      <linearGradient
        id='s-3ed5450257-k'
        x1='-2619.65'
        x2='-2619.4'
        y1='348.24'
        y2='348.24'
        xlinkHref='#s-3ed5450257-a'
      />
      <linearGradient
        id='s-3ed5450257-l'
        x1='-2618.54'
        x2='-2618.29'
        y1='348.18'
        y2='348.18'
        xlinkHref='#s-3ed5450257-a'
      />
      <linearGradient
        id='s-3ed5450257-m'
        x1='-2617.35'
        x2='-2617.1'
        y1='348.14'
        y2='348.14'
        xlinkHref='#s-3ed5450257-a'
      />
      <linearGradient
        id='s-3ed5450257-n'
        x1='-2616.24'
        x2='-2615.99'
        y1='348.02'
        y2='348.02'
        xlinkHref='#s-3ed5450257-a'
      />
      <linearGradient
        id='s-3ed5450257-o'
        x1='-2615.16'
        x2='-2614.91'
        y1='347.95'
        y2='347.95'
        xlinkHref='#s-3ed5450257-a'
      />
      <linearGradient
        id='s-3ed5450257-p'
        x1='-2613.98'
        x2='-2613.73'
        y1='347.92'
        y2='347.92'
        xlinkHref='#s-3ed5450257-a'
      />
      <linearGradient
        id='s-3ed5450257-q'
        x1='-2612.86'
        x2='-2612.61'
        y1='347.86'
        y2='347.86'
        xlinkHref='#s-3ed5450257-a'
      />
      <linearGradient
        id='s-3ed5450257-r'
        x1='-2633.85'
        x2='-2617.57'
        y1='338.64'
        y2='338.64'
        gradientTransform='matrix(-.99 0 0 1 -2462.58 -269.2)'
        xlinkHref='#s-3ed5450257-a'
      />
      <linearGradient
        id='s-3ed5450257-s'
        x1='-2633.85'
        x2='-2617.57'
        y1='337.19'
        y2='337.19'
        gradientTransform='matrix(-.99 0 0 1 -2462.58 -269.2)'
        xlinkHref='#s-3ed5450257-a'
      />
      <linearGradient
        id='s-3ed5450257-t'
        x1='-2633.84'
        x2='-2617.56'
        y1='335.81'
        y2='335.81'
        gradientTransform='matrix(-.99 0 0 1 -2462.58 -269.2)'
        xlinkHref='#s-3ed5450257-a'
      />
      <linearGradient
        id='s-3ed5450257-u'
        x1='-2633.84'
        x2='-2617.56'
        y1='334.35'
        y2='334.35'
        gradientTransform='matrix(-.99 0 0 1 -2462.58 -269.2)'
        xlinkHref='#s-3ed5450257-a'
      />
      <linearGradient
        id='s-3ed5450257-v'
        x1='-2633.83'
        x2='-2617.55'
        y1='332.97'
        y2='332.97'
        gradientTransform='matrix(-.99 0 0 1 -2462.58 -269.2)'
        xlinkHref='#s-3ed5450257-a'
      />
      <linearGradient
        id='s-3ed5450257-w'
        x1='-2633.96'
        x2='-2617.68'
        y1='368.33'
        y2='368.33'
        gradientTransform='matrix(-.99 0 0 1 -2462.58 -269.2)'
        xlinkHref='#s-3ed5450257-a'
      />
      <linearGradient
        id='s-3ed5450257-x'
        x1='-2633.97'
        x2='-2617.69'
        y1='369.54'
        y2='369.54'
        gradientTransform='matrix(-.99 0 0 1 -2462.58 -269.2)'
        xlinkHref='#s-3ed5450257-a'
      />
      <linearGradient
        id='s-3ed5450257-y'
        x1='-2633.96'
        x2='-2617.68'
        y1='366.95'
        y2='366.95'
        gradientTransform='matrix(-.99 0 0 1 -2462.58 -269.2)'
        xlinkHref='#s-3ed5450257-a'
      />
      <linearGradient
        id='s-3ed5450257-z'
        x1='-2633.95'
        x2='-2617.67'
        y1='365.5'
        y2='365.5'
        gradientTransform='matrix(-.99 0 0 1 -2462.58 -269.2)'
        xlinkHref='#s-3ed5450257-a'
      />
      <linearGradient
        id='s-3ed5450257-A'
        x1='-2633.95'
        x2='-2617.67'
        y1='364.11'
        y2='364.11'
        gradientTransform='matrix(-.99 0 0 1 -2462.58 -269.2)'
        xlinkHref='#s-3ed5450257-a'
      />
      <linearGradient
        id='s-3ed5450257-B'
        x1='-2633.94'
        x2='-2617.66'
        y1='362.66'
        y2='362.66'
        gradientTransform='matrix(-.99 0 0 1 -2462.58 -269.2)'
        xlinkHref='#s-3ed5450257-a'
      />
      <linearGradient
        id='s-3ed5450257-C'
        x1='-2633.94'
        x2='-2617.66'
        y1='361.28'
        y2='361.28'
        gradientTransform='matrix(-.99 0 0 1 -2462.58 -269.2)'
        xlinkHref='#s-3ed5450257-a'
      />
      <linearGradient
        id='s-3ed5450257-D'
        x1='-2633.93'
        x2='-2617.65'
        y1='359.83'
        y2='359.83'
        gradientTransform='matrix(-.99 0 0 1 -2462.58 -269.2)'
        xlinkHref='#s-3ed5450257-a'
      />
      <linearGradient
        id='s-3ed5450257-E'
        x1='-2633.92'
        x2='-2617.65'
        y1='358.44'
        y2='358.44'
        gradientTransform='matrix(-.99 0 0 1 -2462.58 -269.2)'
        xlinkHref='#s-3ed5450257-a'
      />
      <linearGradient
        id='s-3ed5450257-F'
        x1='-2633.92'
        x2='-2617.64'
        y1='356.99'
        y2='356.99'
        gradientTransform='matrix(-.99 0 0 1 -2462.58 -269.2)'
        xlinkHref='#s-3ed5450257-a'
      />
      <linearGradient
        id='s-3ed5450257-G'
        x1='-2633.91'
        x2='-2617.64'
        y1='355.57'
        y2='355.57'
        gradientTransform='matrix(-.99 0 0 1 -2462.58 -269.2)'
        xlinkHref='#s-3ed5450257-a'
      />
      <linearGradient
        id='s-3ed5450257-H'
        x1='-2633.91'
        x2='-2617.63'
        y1='354.12'
        y2='354.12'
        gradientTransform='matrix(-.99 0 0 1 -2462.58 -269.2)'
        xlinkHref='#s-3ed5450257-a'
      />
      <linearGradient
        id='s-3ed5450257-I'
        x1='-2633.9'
        x2='-2617.63'
        y1='352.74'
        y2='352.74'
        gradientTransform='matrix(-.99 0 0 1 -2462.58 -269.2)'
        xlinkHref='#s-3ed5450257-a'
      />
      <linearGradient
        id='s-3ed5450257-J'
        x1='-2633.9'
        x2='-2617.62'
        y1='351.28'
        y2='351.28'
        gradientTransform='matrix(-.99 0 0 1 -2462.58 -269.2)'
        xlinkHref='#s-3ed5450257-a'
      />
      <linearGradient
        id='s-3ed5450257-K'
        x1='-2633.89'
        x2='-2617.62'
        y1='349.9'
        y2='349.9'
        gradientTransform='matrix(-.99 0 0 1 -2462.58 -269.2)'
        xlinkHref='#s-3ed5450257-a'
      />
      <linearGradient
        id='s-3ed5450257-L'
        x1='-2633.89'
        x2='-2617.61'
        y1='348.45'
        y2='348.45'
        gradientTransform='matrix(-.99 0 0 1 -2462.58 -269.2)'
        xlinkHref='#s-3ed5450257-a'
      />
      <linearGradient
        id='s-3ed5450257-M'
        x1='-2633.88'
        x2='-2617.61'
        y1='347.07'
        y2='347.07'
        gradientTransform='matrix(-.99 0 0 1 -2462.58 -269.2)'
        xlinkHref='#s-3ed5450257-a'
      />
      <linearGradient
        id='s-3ed5450257-N'
        x1='-2633.88'
        x2='-2617.6'
        y1='345.61'
        y2='345.61'
        gradientTransform='matrix(-.99 0 0 1 -2462.58 -269.2)'
        xlinkHref='#s-3ed5450257-a'
      />
      <linearGradient
        id='s-3ed5450257-O'
        x1='-2633.87'
        x2='-2617.59'
        y1='344.23'
        y2='344.23'
        gradientTransform='matrix(-.99 0 0 1 -2462.58 -269.2)'
        xlinkHref='#s-3ed5450257-a'
      />
      <linearGradient
        id='s-3ed5450257-P'
        x1='-2633.87'
        x2='-2617.59'
        y1='342.78'
        y2='342.78'
        gradientTransform='matrix(-.99 0 0 1 -2462.58 -269.2)'
        xlinkHref='#s-3ed5450257-a'
      />
      <linearGradient
        id='s-3ed5450257-Q'
        x1='-2633.86'
        x2='-2617.58'
        y1='341.39'
        y2='341.39'
        gradientTransform='matrix(-.99 0 0 1 -2462.58 -269.2)'
        xlinkHref='#s-3ed5450257-a'
      />
      <linearGradient
        id='s-3ed5450257-R'
        x1='-2633.86'
        x2='-2617.58'
        y1='339.94'
        y2='339.94'
        gradientTransform='matrix(-.99 0 0 1 -2462.58 -269.2)'
        xlinkHref='#s-3ed5450257-a'
      />
      <linearGradient
        id='s-3ed5450257-S'
        x1='135.54'
        x2='154.64'
        y1='71.03'
        y2='71.03'
        xlinkHref='#s-3ed5450257-a'
      />
      <radialGradient
        id='s-3ed5450257-T'
        cx='138.95'
        cy='67.78'
        r='1.36'
        gradientUnits='userSpaceOnUse'
      >
        <stop
          offset='0'
          stopColor='#999'
        />
        <stop
          offset='1'
          stopColor='#4d4d4d'
        />
      </radialGradient>
      <linearGradient
        id='s-3ed5450257-U'
        x1='470.96'
        x2='470.99'
        y1='343.85'
        y2='343.34'
        gradientTransform='matrix(1.11 .01 .01 1 -383.92 -278.24)'
        gradientUnits='userSpaceOnUse'
      >
        <stop
          offset='0'
          stopColor='#4d4d4d'
        />
        <stop
          offset='.5'
          stopColor='#949494'
        />
        <stop
          offset='1'
          stopColor='#4d4d4d'
        />
      </linearGradient>
      <linearGradient
        id='s-3ed5450257-V'
        x1='1963.15'
        x2='1963.37'
        y1='755.32'
        y2='754.89'
        gradientTransform='rotate(-27.38 391.605 3461.088)'
        gradientUnits='userSpaceOnUse'
      >
        <stop
          offset='0'
          stopColor='#d45a24'
        />
        <stop
          offset='.84'
          stopColor='#a2272d'
        />
      </linearGradient>
      <linearGradient
        id='s-3ed5450257-W'
        x1='720.58'
        x2='720.98'
        y1='1000.81'
        y2='1000.94'
        gradientTransform='matrix(-.28 -1.17 .81 -.19 -66.1 1371.56)'
        gradientUnits='userSpaceOnUse'
      >
        <stop
          offset='0'
          stopColor='#f15a24'
        />
        <stop
          offset='.83'
          stopColor='#a6272d'
        />
      </linearGradient>
      <linearGradient
        id='s-3ed5450257-b'
        x1='540.97'
        x2='541.13'
        y1='334.75'
        y2='334.75'
        gradientUnits='userSpaceOnUse'
      >
        <stop
          offset='0'
          stopColor='#be1e2d'
        />
        <stop
          offset='1'
          stopColor='#ee4036'
        />
      </linearGradient>
      <linearGradient
        id='s-3ed5450257-X'
        x1='539.41'
        x2='548.46'
        y1='335.83'
        y2='335.83'
        xlinkHref='#s-3ed5450257-b'
      />
      <linearGradient
        id='s-3ed5450257-c'
        x1='446.11'
        x2='446.11'
        y1='387.51'
        y2='402.23'
        gradientUnits='userSpaceOnUse'
      >
        <stop
          offset='0'
          stopColor='#c1272d'
        />
        <stop
          offset='.53'
          stopColor='#c6594b'
        />
        <stop
          offset='1'
          stopColor='#c1272d'
        />
      </linearGradient>
      <linearGradient
        id='s-3ed5450257-Y'
        x1='429.92'
        x2='462.78'
        y1='394.29'
        y2='394.29'
        xlinkHref='#s-3ed5450257-c'
      />
      <linearGradient
        id='s-3ed5450257-Z'
        x1='451.65'
        x2='462.61'
        y1='377.29'
        y2='377.29'
        xlinkHref='#s-3ed5450257-c'
      />
      <linearGradient
        id='s-3ed5450257-aa'
        x1='430.81'
        x2='441.77'
        y1='389.62'
        y2='389.62'
        xlinkHref='#s-3ed5450257-c'
      />
      <linearGradient
        id='s-3ed5450257-ab'
        x1='440.9'
        x2='463.22'
        y1='384.07'
        y2='384.07'
        xlinkHref='#s-3ed5450257-c'
      />
      <linearGradient
        id='s-3ed5450257-ac'
        x1='441.83'
        x2='463.23'
        y1='384.46'
        y2='384.46'
        xlinkHref='#s-3ed5450257-c'
      />
      <linearGradient
        id='s-3ed5450257-ad'
        x1='-1052.34'
        x2='-1052.34'
        y1='398.96'
        y2='419.41'
        gradientTransform='matrix(-1 0 0 1 -770.32 -276.72)'
        xlinkHref='#s-3ed5450257-c'
      />
      <linearGradient
        id='s-3ed5450257-ae'
        x1='-1060.46'
        x2='-1043.76'
        y1='408.45'
        y2='408.45'
        gradientTransform='matrix(-1 0 0 1 -770.32 -276.72)'
        xlinkHref='#s-3ed5450257-c'
      />
      <linearGradient
        id='s-3ed5450257-af'
        x1='624.5'
        x2='634.95'
        y1='389.41'
        y2='389.41'
        xlinkHref='#s-3ed5450257-c'
      />
      <linearGradient
        id='s-3ed5450257-ag'
        x1='631.03'
        x2='641.18'
        y1='408.01'
        y2='408.01'
        xlinkHref='#s-3ed5450257-c'
      />
      <linearGradient
        id='s-3ed5450257-ah'
        x1='624.35'
        x2='631.34'
        y1='399.17'
        y2='399.17'
        xlinkHref='#s-3ed5450257-c'
      />
    </defs>
    <g
      id='surface'
      
    >
      <g
        id='mainSurface'
      >
        <path
          d='M313.35 184.03L1.64 161.55 125.83 88.9l156.62 9.48 30.9 85.65z'
          style={{
            fill: '#4d4d4d',
            stroke: '#fff',
            strokeMiterlimit: '10',
          }}
        />
        <path
          d='M299.79 175.04L27 155.32l101.81-60.76 147.19 9.1 23.79 71.38z'
          style={{
            stroke: '#fff',
            strokeMiterlimit: '10',
          }}
        />
        <path
          d='M149.1 172.19l53.09-78.79'
          style={{
            fill: 'none',
            stroke: '#fff',
            strokeMiterlimit: '10',
          }}
        />
      </g>
      <path
        id='surfaceBasket'
        className='basketball'
        d='M210.75 118.4l-50.88-2.57 14.44-18.29 46.45 2.61-10.01 18.25z'
      />
    </g>
    <g
      id='lines'
    >
      <g
        id='basketballLines'
        className='basketball'
      >
        <path
          d='M479.56 371.77C442.33 407 620.93 415.53 627 380.06'
          style={{
            fill: 'none',
            stroke: '#fff',
            strokeMiterlimit: '10',
          }}
          transform='translate(-351.37 -276.72)'
        />
        <path
          d='M210.75 118.4l-50.88-2.57 14.44-18.29 46.45 2.61-10.01 18.25z'
          style={{
            fill: 'none',
            stroke: '#fff',
            strokeMiterlimit: '10',
          }}
        />
        <path
          d='M562.12 395.12c-3.47 4.33-12.86 7.39-25.28 7.19-14.14-.23-27.82-3.56-25.61-9.93'
          style={{
            fill: 'none',
            stroke: '#fff',
            strokeMiterlimit: '10',
          }}
          transform='translate(-351.37 -276.72)'
        />
      </g>
    </g>
    <image
      id='high'
      width='1293'
      height='784'
      transform='translate(4.55) scale(.24)'
      xlinkHref={_10x81}
      
    />
    <image
      id='medium'
      width='1276'
      height='664'
      transform='matrix(.24 0 0 .24 3.83 16.8)'
      xlinkHref={_10x82}
      
    />
    <image
      id='small'
      width='1251'
      height='600'
      transform='matrix(.24 0 0 .24 10.07 29.28)'
      xlinkHref={_10x83}
      
    />
    <g
      id='wicket'
    >
      <path
        d='M154.14 90.83l-18.1-1.03V51.36l18.1 1.06v38.41z'
        style={{
          fill: '#fff',
        }}
      />
      <path
        d='M153.91 62.53l-.85-.07V59.1l.85.06v3.37zM153.91 83.83l-.85-.07v-3.37l.85.07v3.37z'
        style={{
          fill: '#999',
        }}
      />
      <path
        d='M153.07 53.89v36.33'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-3ed5450257-a)',
        }}
      />
      <path
        d='M151.88 53.82v36.36'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-3ed5450257-d)',
        }}
      />
      <path
        d='M150.76 53.77v36.35'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-3ed5450257-e)',
        }}
      />
      <path
        d='M149.66 53.65v36.42'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-3ed5450257-f)',
        }}
      />
      <path
        d='M148.47 53.59V90'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-3ed5450257-g)',
        }}
      />
      <path
        d='M147.35 53.52v36.41'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-3ed5450257-h)',
        }}
      />
      <path
        d='M146.23 53.46v36.4'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-3ed5450257-i)',
        }}
      />
      <path
        d='M145.04 53.38V89.8'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-3ed5450257-j)',
        }}
      />
      <path
        d='M143.93 53.31v36.43'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-3ed5450257-k)',
        }}
      />
      <path
        d='M142.82 53.25v36.43'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-3ed5450257-l)',
        }}
      />
      <path
        d='M141.63 53.25v36.34'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-3ed5450257-m)',
        }}
      />
      <path
        d='M140.52 53.1v36.4'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-3ed5450257-n)',
        }}
      />
      <path
        d='M139.45 53.07V89.4'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-3ed5450257-o)',
        }}
      />
      <path
        d='M138.26 53.01V89.4'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-3ed5450257-p)',
        }}
      />
      <path
        d='M137.14 52.93v36.41'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-3ed5450257-q)',
        }}
      />
      <path
        d='M153.07 59.49l-15.93-.93'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-3ed5450257-r)',
        }}
      />
      <path
        d='M153.07 58.04l-15.93-.93'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-3ed5450257-s)',
        }}
      />
      <path
        d='M153.07 56.66l-15.93-.93'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-3ed5450257-t)',
        }}
      />
      <path
        d='M153.07 55.21l-15.93-.93'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-3ed5450257-u)',
        }}
      />
      <path
        d='M153.07 53.83l-15.93-.93'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-3ed5450257-v)',
        }}
      />
      <path
        d='M153.07 89.12l-15.93-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-3ed5450257-w)',
        }}
      />
      <path
        d='M153.07 90.32l-15.93-.93'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-3ed5450257-x)',
        }}
      />
      <path
        d='M153.07 87.74l-15.93-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-3ed5450257-y)',
        }}
      />
      <path
        d='M153.07 86.29l-15.93-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-3ed5450257-z)',
        }}
      />
      <path
        d='M153.07 84.91l-15.93-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-3ed5450257-A)',
        }}
      />
      <path
        d='M153.07 83.46l-15.93-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-3ed5450257-B)',
        }}
      />
      <path
        d='M153.07 82.08l-15.93-.93'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-3ed5450257-C)',
        }}
      />
      <path
        d='M153.07 80.63l-15.93-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-3ed5450257-D)',
        }}
      />
      <path
        d='M153.07 79.25l-15.93-.93'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-3ed5450257-E)',
        }}
      />
      <path
        d='M153.07 77.8l-15.93-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-3ed5450257-F)',
        }}
      />
      <path
        d='M153.07 76.39l-15.93-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-3ed5450257-G)',
        }}
      />
      <path
        d='M153.07 74.94L137.14 74'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-3ed5450257-H)',
        }}
      />
      <path
        d='M153.07 73.56l-15.93-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-3ed5450257-I)',
        }}
      />
      <path
        d='M153.07 72.11l-15.93-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-3ed5450257-J)',
        }}
      />
      <path
        d='M153.07 70.73l-15.93-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-3ed5450257-K)',
        }}
      />
      <path
        d='M153.07 69.28l-15.93-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-3ed5450257-L)',
        }}
      />
      <path
        d='M153.07 67.9l-15.93-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-3ed5450257-M)',
        }}
      />
      <path
        d='M153.07 66.45l-15.93-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-3ed5450257-N)',
        }}
      />
      <path
        d='M153.07 65.07l-15.93-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-3ed5450257-O)',
        }}
      />
      <path
        d='M153.07 63.62l-15.93-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-3ed5450257-P)',
        }}
      />
      <path
        d='M153.07 62.24l-15.93-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-3ed5450257-Q)',
        }}
      />
      <path
        d='M153.07 60.79l-15.93-.94'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.25px',
          stroke: 'url(#s-3ed5450257-R)',
        }}
      />
      <path
        d='M136.04 89.61V51.42l18.1 1.05v38.18'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          stroke: 'url(#s-3ed5450257-S)',
        }}
      />
      <circle
        cx='138.95'
        cy='67.78'
        r='1.36'
        style={{
          fill: 'url(#s-3ed5450257-T)',
        }}
      />
      <path
        d='M138.95 67.78l3.46.16'
        style={{
          fill: 'none',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: '.5px',
          stroke: 'url(#s-3ed5450257-U)',
        }}
      />
    </g>
    <g
      id='basketballAcross'
      className='basketball'
    >
      <path
        d='M198.89 99.57l-2.1-.12V54.6l2.1-.01v44.98z'
        style={{
          fill: '#666',
        }}
      />
      <path
        d='M198.89 99.57l1.04-.58V54.25l-1.04.34v44.98z'
        style={{
          fill: '#333',
        }}
      />
      <path
        d='M199.93 54.25l-1.04.34h-2.67l1.85-.41 1.86.07z'
        style={{
          fill: '#858589',
        }}
      />
      <path
        d='M198.62 70.92l-1.83-.15-3.22-14.24 1.83.15 3.22 14.24z'
        style={{
          fill: '#4d4d4d',
        }}
      />
      <path
        d='M198.62 66.28v4.64l-3.21-14.24h-2.03l.98-1.01h1.86l2.4 10.61z'
        style={{
          fill: '#333',
        }}
      />
      <path
        d='M559 325c-1.4-4.76-6.46-8.29-12.49-8.29s-10.46 2.14-11.86 6.91v6.07l5.87 6.19 12.14.7 6.3-5.49v-.07z'
        style={{
          fill: '#fff',
        }}
        transform='translate(-351.37 -276.72)'
      />
      <path
        d='M552.67 336.64l-12.21-.71-5.91-6.24v-6.1c1.34-4.56 5.47-7 11.94-7 5.95 0 11.12 3.44 12.57 8.35V331.1zm-12.13-.88l12.07.7 6.25-5.45v-6c-1.43-4.84-6.53-8.22-12.4-8.22-6.38 0-10.45 2.37-11.77 6.84v6z'
        style={{
          fill: '#1a1a1a',
        }}
        transform='translate(-351.37 -276.72)'
      />
      <path
        d='M552.09 336l-11.39-.67-5.54-5.85v-5.75c1.26-4.29 5.12-6.55 11.16-6.55 5.56 0 10.39 3.21 11.75 7.82V330.81l-.07.19zm-11.16-1.16l11 .63 5.64-4.86v-5.5c-1.31-4.37-5.93-7.42-11.25-7.42-4 0-9.15 1.07-10.66 6.14v5.48z'
        style={{
          fill: '#1a1a1a',
        }}
        transform='translate(-351.37 -276.72)'
      />
      <path
        d='M195.88 59l-2.47-.15v-2.33l2.47.14V59z'
        style={{
          fill: '#c1272d',
        }}
      />
      <path
        d='M550.78 333.82l-9.17-.51v-7.59l9.17.51zm-8.55-1.1l7.93.44v-6.35l-7.93-.44z'
        style={{
          fill: '#1a1a1a',
        }}
        transform='translate(-351.37 -276.72)'
      />
      <path
        d='M546.29 334.17a2.81 2.81 0 0 0-1.15-.25 4.13 4.13 0 0 0-1.36.08l1-.76 2.47.13z'
        style={{
          fill: '#ea371f',
        }}
        transform='translate(-351.37 -276.72)'
      />
      <path
        d='M545.68 335.29l-5.79.24a.12.12 0 0 1-.15-.09.12.12 0 0 1 .08-.15l5.78-.24a.13.13 0 0 1 .1.24z'
        style={{
          fill: 'url(#s-3ed5450257-V)',
        }}
        transform='translate(-351.37 -276.72)'
      />
      <path
        d='M548.33 335.78a.22.22 0 0 1 0 .14c0 .07-.11.07-.17 0l-2.06-.63a.24.24 0 0 1 0-.24.1.1 0 0 1 .17 0l2.06.64a.16.16 0 0 1 0 .09z'
        style={{
          fill: 'url(#s-3ed5450257-W)',
        }}
        transform='translate(-351.37 -276.72)'
      />
      <path
        d='M540.26 337.6a4.56 4.56 0 0 1-.14-.64l-.18-.12c.06.26.2.51.32.76zM541 337.79c.12.25.25.5.39.74a4.66 4.66 0 0 1-.41-1.17l-.15-.05zM545.3 339.86c.18-.19.35-.39.51-.59 0-.35-.11-.7-.18-1.05a.42.42 0 0 1 0-.1c-.2.29-.4.57-.61.85l.21.61c-.01.07.03.18.07.28zM541.8 336.37l.24.92.58.08c0-.66 0-1.33.1-2a3 3 0 0 1 .13-1.06 8.09 8.09 0 0 0-1.62.37 3.82 3.82 0 0 1 .57 1.69z'
        style={{
          fill: 'none',
        }}
        transform='translate(-351.37 -276.72)'
      />
      <path
        d='M541.42 338.48a5 5 0 0 0 .82 1.16 2.8 2.8 0 0 0 .09-.31c0-.12.06-.24.09-.37a10.28 10.28 0 0 1-.34-1 2.92 2.92 0 0 1-.24-.37 7.11 7.11 0 0 1-.8-.21 4.21 4.21 0 0 0 .38 1.1zM545.69 338a7.35 7.35 0 0 1 .24 1.17l.05-.06c.06-.51.1-1 .12-1.54h-.17zM543.66 336.58c0-.29-.07-.58-.11-.87a4.43 4.43 0 0 0-.16-1c0-.08-.11-.25-.2-.27s-.22.18-.26.32a4.43 4.43 0 0 0-.08.9c0 .54 0 1.14-.07 1.76h1c-.07-.27-.09-.55-.12-.84zM543.9 337.79v.23c0-.08.06-.16.09-.23h-.1zM546.15 338.82a5.4 5.4 0 0 0 .4-.65 5.29 5.29 0 0 0 .06-.8l-.36.11c-.01.44-.05.89-.1 1.34zM545.62 337.75a1.4 1.4 0 0 0 .1-.16h-.12c.01.08.01.12.02.16zM543.78 338.27v-.48h-.32a5.92 5.92 0 0 1 .32.48zM542.21 337.9l.32.41c0-.19 0-.39.05-.58l-.44-.06c.02.07.04.15.07.23zM542.68 338.52l.31.42c.1.13.2.25.29.38.13-.24.24-.47.36-.71l.06-.13c-.13-.23-.26-.46-.37-.7h-.57c-.02.22-.04.48-.08.74zM543.93 338.33v.19c.18.29.34.59.49.88l.42-.52c-.13-.37-.26-.74-.36-1.12h-.32c-.07.24-.16.39-.23.57zM546.74 337.66c0-.13.08-.25.12-.38a.42.42 0 0 1-.12 0 1.93 1.93 0 0 1 0 .38zM544.92 338.76c.21-.28.42-.57.61-.86l-.06-.25c-.29.05-.6.08-.92.11.14.33.26.66.37 1zM545.56 337.27l.42-.09c.11-.19.22-.38.32-.57a12.67 12.67 0 0 1 .84-1.83 6.05 6.05 0 0 0-1.69-.45 2.15 2.15 0 0 1 0 .23c.12.9.02 1.81.11 2.71zM548.1 335.74c0-.3-.27-.6-.72-.85a7.81 7.81 0 0 1-.24 1.88c.62-.31.97-.68.96-1.03zM540.53 338.12c.18.33.37.65.58 1v.11c.22.32.45.64.69 1l.1.12c0-.11.1-.22.14-.33a9.38 9.38 0 0 1-1-1.38 7 7 0 0 1-.55-1.3 2.25 2.25 0 0 1-.31-.16 10.52 10.52 0 0 0 .35.94zM540.21 336.6l.26.17c-.12-.39-.23-.78-.32-1.18a6.77 6.77 0 0 0 .06 1.01z'
        style={{
          fill: 'none',
        }}
        transform='translate(-351.37 -276.72)'
      />
      <path
        d='M543.87 337.43h.28c.07-.21.14-.42.2-.64.15-.55.23-1.12.4-1.67a3.77 3.77 0 0 1 .29-.83 10.48 10.48 0 0 0-1.14 0h-.57a3.78 3.78 0 0 1 .4 1.61c.06.49.11 1.01.14 1.53zM545.35 335.21a3 3 0 0 0 0-.73c-.09-.34-.15-.05-.21.1s-.11.28-.16.42c-.16.49-.25 1-.37 1.51q-.12.47-.27.9a9 9 0 0 0 1.11-.12c-.12-.68-.08-1.37-.1-2.08zM540.86 337a7.92 7.92 0 0 1 0-2.12 2.8 2.8 0 0 0-.69.41c.12.54.27 1.08.44 1.61zM546.39 339.46c.15-.31.29-.61.41-.92a10.14 10.14 0 0 0 .33-1.37h-.09a5.42 5.42 0 0 1-.35.93 8.68 8.68 0 0 1-.3 1.36z'
        style={{
          fill: 'none',
        }}
        transform='translate(-351.37 -276.72)'
      />
      <path
        d='M190.61 60.92z'
        style={{
          fill: 'none',
        }}
      />
      <path
        d='M547 338.23c0 .14-.09.29-.14.44a8.43 8.43 0 0 0 .89-1.87 3 3 0 0 1-.4.24c-.06.42-.18.8-.35 1.19zM547.26 334.83a5.42 5.42 0 0 0-.44 1 12.63 12.63 0 0 1-.57 1.17l-.06.1a5.11 5.11 0 0 0 .81-.28 8.09 8.09 0 0 0 .26-1.99zM543.47 340.54l.29-.34-.46-.63-.22.4a5.72 5.72 0 0 0 .39.57zM546.12 339.08c0 .26-.07.51-.12.76a1.7 1.7 0 0 0 .19-.19c.11-.37.22-.75.3-1.13-.12.19-.24.38-.37.56zM545.35 340c0 .13.09.25.13.38l.35-.36v-.12-.45c-.15.19-.32.37-.48.55zM540.9 336a6.17 6.17 0 0 0 .1 1 6.35 6.35 0 0 0 .92.26c-.14-.54-.26-1.07-.39-1.6 0-.13-.16-.81-.36-.93l-.16.06a4.74 4.74 0 0 0-.05.69c-.05.16-.06.32-.06.52zM543.94 338.87v1.12l.39-.48c-.12-.21-.26-.43-.39-.64zM543.21 339.46l-.33-.45c-.08-.09-.15-.19-.23-.29v.31a6.27 6.27 0 0 0 .41.82c.02-.13.09-.26.15-.39zM540 335.37a.82.82 0 0 0-.27.56.84.84 0 0 0 .28.53 8 8 0 0 1-.01-1.09zM543.79 338.62c-.13.27-.27.53-.41.8l.42.56q0-.67-.01-1.36zM544.89 340.27c.11-.1.21-.21.31-.31l-.12-.38-.18-.53-.39.5c0 .07.07.14.1.2s.19.35.28.52zM542.5 338.53l-.16-.19.13.36zM542.92 340l-.12-.2c-.09-.18-.18-.36-.26-.54a3.68 3.68 0 0 1-.16.54l.41.42c.04-.07.09-.14.13-.22zM542.2 339.77c-.16-.19-.31-.37-.45-.57l.43.6z'
        style={{
          fill: 'none',
        }}
        transform='translate(-351.37 -276.72)'
      />
      <path
        d='M540.86 337l.1.05a6.17 6.17 0 0 1-.06-1.05v-.47a4.74 4.74 0 0 1 .05-.69h-.09a7.92 7.92 0 0 0 0 2.16zM542.62 337.37h.16c0-.62 0-1.22.07-1.76a4.43 4.43 0 0 1 .08-.9c0-.14.1-.36.26-.32s.17.19.2.27a4.43 4.43 0 0 1 .16 1c0 .29.08.58.11.87s.05.57.07.85h.14c0-.52-.08-1-.14-1.55a3.78 3.78 0 0 0-.4-1.61l-.48.05a3 3 0 0 0-.13 1.06c-.05.67-.06 1.38-.1 2.04zM540.21 336.6a6.77 6.77 0 0 1-.06-1c.09.4.2.79.32 1.18l.16.08c-.17-.53-.32-1.07-.44-1.61l-.15.13a8 8 0 0 0 0 1.09zM541 334.41a.16.16 0 0 0-.11 0h.11zM541.49 335.66c.13.53.25 1.06.39 1.6h.16l-.24-.92a3.82 3.82 0 0 0-.57-1.68h-.1c.2.19.33.87.36 1z'
        style={{
          fill: '#fff',
        }}
        transform='translate(-351.37 -276.72)'
      />
      <path
        d='M546.9 338.67c.05-.15.09-.3.14-.44.13-.39.25-.77.34-1.16l-.26.13a10.14 10.14 0 0 1-.33 1.37c-.12.31-.26.61-.41.92a8.68 8.68 0 0 0 .3-1.32 5.42 5.42 0 0 0 .35-.93l-.18.07c0 .13-.07.25-.12.38a1.93 1.93 0 0 0 0-.34l-.13.05a5.29 5.29 0 0 1-.06.8 5.4 5.4 0 0 1-.4.65c.05-.45.09-.9.1-1.34h-.15c0 .51-.06 1-.12 1.54l-.05.06a7.35 7.35 0 0 0-.24-1.17l.24-.39h-.21a1.4 1.4 0 0 1-.1.16v-.13h-.13l.06.25c-.19.29-.4.58-.61.86-.11-.34-.23-.67-.37-1h-.07c.1.38.23.75.36 1.12l-.42.52c-.15-.29-.31-.59-.49-.88v-.19c.08-.18.16-.37.23-.55H544c0 .07 0 .15-.09.23v-.23h-.15v.48a5.92 5.92 0 0 0-.35-.48h-.1c.11.24.24.47.37.7l-.06.13c-.12.24-.23.47-.36.71-.09-.13-.19-.25-.29-.38l-.31-.42c0-.26.06-.52.08-.78h-.18c0 .19 0 .39-.05.58l-.32-.41c0-.08-.05-.16-.07-.23H541.82a2.92 2.92 0 0 0 .24.37 10.28 10.28 0 0 0 .34 1c0 .13 0 .25-.09.37a2.8 2.8 0 0 1-.09.31 5 5 0 0 1-.82-1.16 4.21 4.21 0 0 1-.38-1.08h-.11a4.66 4.66 0 0 0 .41 1.17c-.14-.24-.27-.49-.39-.74l-.17-.48-.18-.08a7 7 0 0 0 .55 1.3 9.38 9.38 0 0 0 1 1.38c0 .11-.09.22-.14.33l-.1-.12a9.74 9.74 0 0 1-.69-1v-.11c-.21-.32-.4-.64-.58-1a10.52 10.52 0 0 1-.24-1.05l-.17-.11a4.56 4.56 0 0 0 .14.64c-.12-.25-.22-.5-.32-.76l-.15-.13a9.67 9.67 0 0 0 1.39 2.71c.1.36.22.72.35 1.07a3.88 3.88 0 0 0 0 .59 11.36 11.36 0 0 1-.09 1.54v.34c-.08.4-.3 1.56.26 1.16a.66.66 0 0 0 .31.24.46.46 0 0 0 .48-.16c.13.23.3.45.54.43a.46.46 0 0 0 .34-.25l.09-.12a.62.62 0 0 0 .86.16 1.31 1.31 0 0 0 .27-.3.93.93 0 0 0 .16.18c.33.24.49-.14.55-.41v-.09c0-.03.11.21.17.32a.08.08 0 0 0 .13 0 6.53 6.53 0 0 0 .08-1.71 7.34 7.34 0 0 1 .08-.82v-.06c0-.27.12-.54.19-.81a.75.75 0 0 0 .07-.12 10 10 0 0 0 .52-1.1.06.06 0 0 0 0-.05l.05-.11a10.66 10.66 0 0 0 1.31-2.64l-.21.16a8.43 8.43 0 0 1-.88 1.86zm-1.31-.58a.42.42 0 0 0 0 .1c.07.35.14.7.18 1.05-.16.2-.33.4-.51.59 0-.1-.08-.21-.11-.31l-.21-.61c.25-.25.45-.53.65-.82zm-3.88 2.91l.21.48-.19.22c0-.21-.07-.41-.09-.61zm-.08 0a2.45 2.45 0 0 1 0-.27 1.46 1.46 0 0 0 .07.19zm.35.63l.21.43-.3.37a5.63 5.63 0 0 1-.14-.59zm1.55-.41l-.2-.18zm-.09-.3l.06-.08c.12.15.25.29.38.44l-.07.06zm.2.58l-.41.39-.3-.38.32-.37zm-.34-.73l-.41-.42.11-.19a6.15 6.15 0 0 0 .37.52zm-.1.11a.6.6 0 0 0-.08-.08l-.31-.3zm-.1.12l-.3.35-.29-.37.21-.34zm-.39.44l-.43.51c-.07-.14-.14-.28-.2-.43a5 5 0 0 0 .35-.43zm-.43.8l.23.43a1.34 1.34 0 0 1-.11.14l-.27.35c-.07-.18-.13-.36-.19-.54zm.16 0l-.06-.11.47-.53.29.37c-.18.19-.36.38-.53.58zm.79-.15l.37.48c-.07.09-.15.18-.22.28l-.35.43-.34-.6c.17-.22.31-.42.54-.61zm.09-.09l.26-.26c0-.05.11-.1.16-.16.13.12.25.25.37.38l-.43.51c-.11-.18-.24-.34-.36-.47zm1.47-.52l.34-.39c.07.14.14.28.2.42l-.28.39zm.13.59l-.1.13c-.1-.14-.21-.27-.32-.4l.16-.18c.09.13.18.28.26.43zm-.25-.77l-.24-.37.42-.41.19.37zm-.11.14l-.19.21-.31-.35.26-.25c.08.1.16.23.24.37zm-.26.3l-.1.11-.06-.06c-.08-.12-.16-.24-.25-.35l.07-.07c.12.1.23.23.34.35zm-.06.36c.11.13.21.26.31.4l-.1.12c-.13.14-.25.28-.37.43l-.06-.1c-.08-.12-.17-.23-.25-.34zm.22.05l-.13-.15.09-.11.33.4-.09.11a2.43 2.43 0 0 0-.2-.27zm.37.24c.08.12.17.24.24.36l-.06.16-.27-.4zm.07-.09l.09-.11c0 .11.11.22.17.33v.1a3.62 3.62 0 0 0-.26-.34zm.22-.27l.28-.38v.06l-.18.56zm.12-1.06l.22-.24c0 .13.09.26.13.39l-.16.25a2.09 2.09 0 0 0-.19-.37zm-.1-.2l-.18-.35.29-.3c0 .13.09.26.13.39zm-.24-1.7l.18.53.12.38c-.1.1-.2.21-.31.31-.09-.17-.18-.35-.28-.52s-.07-.13-.1-.2zm-.44.69c.12.21.22.42.33.64l-.44.42-.31-.44a.83.83 0 0 0-.08-.12l.46-.57zm-.52-.87c.13.21.27.43.39.64l-.39.48c.06-.39.06-.77 0-1.14zm0 1.56c.11.15.22.31.32.47l-.16.15-.12.12-.37-.47.28-.35a.35.35 0 0 1 .03.06zm-.54-1c.14-.27.28-.53.41-.8v1.38l-.42-.56zm-.08.15l.46.63-.29.34a5.72 5.72 0 0 1-.39-.57zm-.65-.85c.08.1.15.2.23.29l.33.45c-.06.13-.13.26-.2.39a6.27 6.27 0 0 1-.41-.82c0-.13.01-.24.03-.34zm-.31-.38l.16.19v.17zm.2.92c.08.18.17.36.26.54l.12.2c0 .08-.09.15-.13.22l-.41-.42a3.68 3.68 0 0 0 .14-.57zm-.2.67c.12.14.25.28.38.41a5 5 0 0 1-.37-.42zm-.59-.73c.14.2.29.38.45.57zm.51.91l.36.39-.21.33-.31-.39c.04-.14.09-.25.14-.36zm-.23.44l.3.39c-.1.14-.21.27-.32.41-.07-.16-.14-.32-.2-.48a3.62 3.62 0 0 0 .17-.35zm-.67-.88c.18.25.37.5.56.74l-.16.33c-.17-.39-.3-.77-.42-1.1zm.27 2.28c0 .2.09.39.15.59l-.23.3c-.01-.33.04-.63.06-.87zm-.19 1.48a1.17 1.17 0 0 0 .09.32c-.18-.14-.14-.17-.11-.35zm.27.38a1.78 1.78 0 0 1-.14-.5 3 3 0 0 1 0-.31l.29-.3c.07.19.14.38.22.56-.09.13-.17.26-.25.39s-.11.11-.14.13zm.1.13c.06-.1.1-.2.15-.29l.15-.24.21.41.1.2c-.16.1-.34.15-.63-.11zm.55-.32c-.06-.11-.11-.22-.16-.33s.2-.28.31-.41l.08-.1.34.61c-.1.11-.19.23-.28.34l-.13.18zm.64.6c-.3 0-.31 0-.4-.17l.06-.08.35-.43a5 5 0 0 0 .35.54c-.09.12-.09.11-.38.11zm.44-.27c-.09-.14-.16-.29-.22-.39l-.1-.16c.19-.24.39-.47.59-.71l.08.12c.08.11.16.21.23.32-.14.18-.28.36-.41.55s-.14.15-.19.29zm1.08 0a.64.64 0 0 1-.8.29.86.86 0 0 1-.18-.16c.14-.22.26-.44.41-.64l.16-.21c.09.14.18.27.26.41a2.48 2.48 0 0 1 .17.29zm.08-.15a5.32 5.32 0 0 1-.42-.66l.47-.57c.1.15.2.3.29.45-.08.22-.17.43-.27.64zm.66-.14c0 .11 0 .22-.07.33-.24.11-.4.1-.49 0a5 5 0 0 0 .33-.8l.24.43s-.03.02-.03.04zm0-.3l-.21-.36a.88.88 0 0 0 0-.15 2.48 2.48 0 0 1 .17.32 1.49 1.49 0 0 1 .06.19zm0-.42l-.13-.24v-.08l.11.2a.49.49 0 0 0 .08.15zm0-.57l.06-.17a2.28 2.28 0 0 0 0 .26.36.36 0 0 1-.01-.09zm.23 1.47c0-.1-.1-.2-.16-.3a1 1 0 0 0 0-.16c.05.12.09.25.13.38zm0-.27a2.86 2.86 0 0 0-.15-.41.57.57 0 0 1 0-.13l.16.31c.09.07.09.15.08.23zm0-1.44v.9l-.14-.33c0-.26 0-.53.07-.79l.07.14s.1.05.1.08zm0-.32a.5.5 0 0 0 0-.13l.09-.37v.08c.08.14.06.28.04.42zm0-1l-.09-.26.2-.21c.1.18.07.34.03.49zm.11.34v-.1zm.07-1.18l-.35.36c0-.13-.09-.25-.13-.38.16-.18.33-.36.48-.55v.45c0 .15.15.12.14.12zm.23.08v.1-.11l.1-.11zm-.06-.26c0-.25.09-.5.12-.76s.25-.37.37-.56c-.08.38-.19.76-.3 1.13a1.7 1.7 0 0 1-.05.21z'
        style={{
          fill: '#fff',
        }}
        transform='translate(-351.37 -276.72)'
      />
      <path
        d='M544.35 336.78c-.06.22-.13.43-.2.64h.15q.15-.44.27-.9c.12-.5.21-1 .37-1.51 0-.14.1-.28.16-.42s.12-.44.21-.1a3 3 0 0 1 0 .73c0 .71 0 1.4.06 2.08h.15c-.09-.9 0-1.81-.09-2.71a2.15 2.15 0 0 0 0-.23l-.41-.05a3.77 3.77 0 0 0-.29.83c-.15.52-.23 1.09-.38 1.64zM546 337.18l.21-.06.06-.1a12.63 12.63 0 0 0 .57-1.17 5.42 5.42 0 0 1 .44-1 8.09 8.09 0 0 1-.26 2l.14-.07a7.81 7.81 0 0 0 .24-1.88l-.24-.11a12.67 12.67 0 0 0-.84 1.83c-.12.18-.23.38-.32.56z'
        style={{
          fill: '#fff',
        }}
        transform='translate(-351.37 -276.72)'
      />
      <path
        d='M547.38 334.79a.14.14 0 0 0 .1-.15.15.15 0 0 0-.15-.14.15.15 0 0 0-.15.15.43.43 0 0 0 0 .05l-.05.08.24.11zM543.22 334.17a.11.11 0 0 0 0-.05.18.18 0 0 0-.18-.17.17.17 0 0 0-.17.17.24.24 0 0 0 0 .08.24.24 0 0 0-.08.11l.52-.05zM545.6 334.18a.22.22 0 0 0 0-.14.18.18 0 0 0-.21-.09.18.18 0 0 0-.12.12.28.28 0 0 0 0 .09 1 1 0 0 0-.08.11h.44a.5.5 0 0 0-.03-.09zM540.9 334.69a.78.78 0 0 1 0 .14h.09v-.07a.11.11 0 0 1 .12 0h.1a.49.49 0 0 0-.13-.12.14.14 0 0 0-.14-.16h-.11a.16.16 0 0 0 .07.21zM540.19 335.24v-.05a.11.11 0 0 0 0-.08.14.14 0 0 0-.15-.14.15.15 0 0 0-.14.15.14.14 0 0 0 .14.13.49.49 0 0 1 0 .12z'
        style={{
          fill: '#fff',
        }}
        transform='translate(-351.37 -276.72)'
      />
      <path
        d='M541 334.72v.07l.16-.06a.11.11 0 0 0-.16-.01z'
        style={{
          fill: 'url(#s-3ed5450257-b)',
        }}
        transform='translate(-351.37 -276.72)'
      />
      <path
        d='M543.89 333.88a8.76 8.76 0 0 0-2.93.53.14.14 0 0 1 .14.16.49.49 0 0 1 .13.12 8.09 8.09 0 0 1 1.62-.37.27.27 0 0 1 .08-.1.19.19 0 0 1 0-.07.16.16 0 0 1 .16-.16.16.16 0 0 1 .16.15.09.09 0 0 1 0 .05l.11.08h.57a10.48 10.48 0 0 1 1.14 0 .36.36 0 0 1 .08-.09.28.28 0 0 1 0-.09.18.18 0 0 1 .1-.11.17.17 0 0 1 .19.09.24.24 0 0 1 0 .12.5.5 0 0 1 0 .13 6.05 6.05 0 0 1 1.69.45l.05-.08a.43.43 0 0 1 0-.05.15.15 0 0 1 .15-.15.15.15 0 0 1 .15.14.14.14 0 0 1-.1.15v.1c.45.25.71.55.72.85s-.34.72-1 1l-.14.07a5.11 5.11 0 0 1-.81.28l-.21.06-.42.09h-.15a9 9 0 0 1-1.11.12H542.53l-.58-.08h-.16a6.35 6.35 0 0 1-.79-.27l-.1-.05-.23-.1-.16-.08-.26-.17-.16-.14a.84.84 0 0 1-.28-.53.82.82 0 0 1 .27-.56.49.49 0 0 0 0-.12.14.14 0 0 1-.14-.13.15.15 0 0 1 .14-.15.14.14 0 0 1 .15.14.11.11 0 0 1 0 .08v.05a2.69 2.69 0 0 1 .7-.41v-.14a.16.16 0 0 1 0-.24c-.9.38-1.46.91-1.44 1.49a1.08 1.08 0 0 0 .38.77l.15.13.18.12.17.11a2.25 2.25 0 0 0 .31.16l.18.08.15.05h.11a7.11 7.11 0 0 0 .8.21H542.22l.44.06H544.63c.32 0 .63-.06.92-.11h.78l.36-.11.13-.05a.42.42 0 0 0 .12 0l.18-.07h.09l.26-.13a3 3 0 0 0 .4-.24l.21-.16a1.21 1.21 0 0 0 .46-.91c-.1-1.21-2.11-2.02-4.65-1.97z'
        style={{
          fill: 'url(#s-3ed5450257-X)',
        }}
        transform='translate(-351.37 -276.72)'
      />
    </g>
    <g
      id='unihockey'
      
    >
      <g
        id='unihockeyLeft'
      >
        <path
          d='M111.04 135.12l-45.16-2.84 43.06-25.97 40.12 2.67-38.02 26.14z'
          style={{
            fill: 'none',
            stroke: '#fff',
            strokeMiterlimit: '10',
          }}
        />
        <path
          d='M441.83 402.23l-11.91-.75v-1.09L450.78 388a3.07 3.07 0 0 1 2-.41l9.5 1.29v1.09l-9.22-.58a3.08 3.08 0 0 0-1.8.45l-16.7 10.12 7.27 1.23z'
          style={{
            fill: 'url(#s-3ed5450257-c)',
          }}
          transform='translate(-351.37 -276.72)'
        />
        <path
          d='M441.69 401.14l-11.77-.75 21-12.51a3.11 3.11 0 0 1 1.79-.43l10.1.64-.44.58a.39.39 0 0 1-.33.15l-9.14-.58a3.11 3.11 0 0 0-1.79.43l-18.61 11.1 10.39.66-.93.64a.42.42 0 0 1-.27.07z'
          style={{
            fill: 'url(#s-3ed5450257-Y)',
          }}
          transform='translate(-351.37 -276.72)'
        />
        <path
          d='M461.61 368.73a26.14 26.14 0 0 1-5.79-.58v-.11a26.79 26.79 0 0 0 6.25.58v.11zM461.56 368.15a23.72 23.72 0 0 1-5.49-.56v-.11a24.73 24.73 0 0 0 6 .56v.11zM461.66 369.89a27.68 27.68 0 0 1-6.06-.6v-.11a28.14 28.14 0 0 0 6.47.6v.11zM461.64 369.31a27.29 27.29 0 0 1-5.93-.59v-.11a27.24 27.24 0 0 0 6.36.59v.11zM461.58 370.94a28.55 28.55 0 0 1-6.13-.58v-.1a29.43 29.43 0 0 0 6.62.57v.11zM461.67 370.36a28.53 28.53 0 0 1-6.16-.61v-.11a28.92 28.92 0 0 0 6.56.61v.11zM461.63 372.11a31.53 31.53 0 0 1-6.47-.61v-.11a32 32 0 0 0 6.91.61v.11zM461.59 371.53a30.31 30.31 0 0 1-6.32-.59v-.1a31.16 31.16 0 0 0 6.8.57v.11zM461.68 373.27a33.93 33.93 0 0 1-6.74-.63v-.1a34.87 34.87 0 0 0 7.13.62v.11zM461.73 372.69a33.12 33.12 0 0 1-6.67-.68v-.1a33.43 33.43 0 0 0 7 .67v.11zM461.52 374.43a35.9 35.9 0 0 1-6.8-.58v-.11a35.41 35.41 0 0 0 7.35.58v.11zM461.69 373.85a35.89 35.89 0 0 1-6.86-.63v-.11a35.18 35.18 0 0 0 7.24.63v.11zM461.58 375.48a37.68 37.68 0 0 1-7.08-.6v-.1a39.16 39.16 0 0 0 7.57.59v.11zM461.54 374.9a36.3 36.3 0 0 1-6.93-.59v-.11a37.25 37.25 0 0 0 7.46.59v.11zM461.77 376.65a40.37 40.37 0 0 1-7.47-.74v-.1a41.63 41.63 0 0 0 7.77.73v.1zM461.6 376.07a39.8 39.8 0 0 1-7.21-.61v-.11a39.5 39.5 0 0 0 7.68.6v.11zM461.74 377.23a41.5 41.5 0 0 1-7.56-.71v-.11a41.55 41.55 0 0 0 7.89.71v.11zM461.66 378.39a44.24 44.24 0 0 1-7.72-.64v-.11a45.06 45.06 0 0 0 8.13.64v.11zM461.74 377.81a43.3 43.3 0 0 1-7.68-.71v-.11a43.42 43.42 0 0 0 8 .71v.11zM461.5 379.55a46.82 46.82 0 0 1-7.8-.59v-.1a47.77 47.77 0 0 0 8.37.58v.11zM461.46 379a44.83 44.83 0 0 1-7.62-.58v-.11a44.29 44.29 0 0 0 8.23.58v.11zM461.54 380.72a49.85 49.85 0 0 1-8.07-.61V380a50.37 50.37 0 0 0 8.6.61v.11zM461.52 380.14a48.22 48.22 0 0 1-7.93-.6v-.11a49.1 49.1 0 0 0 8.49.6v.1zM461.56 381.77a52.35 52.35 0 0 1-8.29-.62v-.11a52.68 52.68 0 0 0 8.8.62v.11zM461.46 381.19a50.4 50.4 0 0 1-8.08-.58v-.11a51.88 51.88 0 0 0 8.7.58v.1zM461.46 382.93a53 53 0 0 1-8.39-.58v-.11a54.44 54.44 0 0 0 9 .58v.11zM461.69 382.35a52.74 52.74 0 0 1-8.52-.71v-.11a52.87 52.87 0 0 0 8.9.71v.11zM461.41 384.09a55.51 55.51 0 0 1-8.6-.59v-.1a57.34 57.34 0 0 0 9.27.58v.11zM461.39 383.51a55 55 0 0 1-8.45-.58v-.11a54.62 54.62 0 0 0 9.14.58v.11zM461.46 385.26a59 59 0 0 1-8.88-.61v-.1a61.19 61.19 0 0 0 9.49.6v.11zM461.43 384.68a58.55 58.55 0 0 1-8.74-.6v-.11a59.74 59.74 0 0 0 9.38.6v.1zM461.5 386.31a61.87 61.87 0 0 1-9.12-.62v-.11a64 64 0 0 0 9.7.62v.11zM461.48 385.73a61.68 61.68 0 0 1-9-.61v-.11a62.33 62.33 0 0 0 9.58.61v.1zM461.4 387.47a64.66 64.66 0 0 1-9.26-.58v-.11a66.28 66.28 0 0 0 9.93.58v.11zM461.39 386.89a63.34 63.34 0 0 1-9.13-.58v-.11a64 64 0 0 0 9.82.58v.11z'
          style={{
            fill: '#fff',
          }}
          transform='translate(-351.37 -276.72)'
        />
        <path
          d='M101.5 111.13l-.11-.02 3.93-20.78.1.02-3.92 20.78zM102.39 111.13l-.11-.02 3.75-20.85.11.02-3.75 20.85zM109.4 111.67h-.11l.16-21.25.11.01-.16 21.24z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M449.53 377.63h21.2v.11h-21.2z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-89.4 144.21 416.808)'
        />
        <path
          d='M107.9 111.52l-.11-.01.44-21.09h.11l-.44 21.1zM105.25 111.36l-.1-.01 2.27-21.08.11.01-2.28 21.08z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M448.47 377.56h21v.11h-21z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-88.3 139.289 420.28)'
        />
        <path
          d='M446.56 377.42h21.11v.11h-21.11z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-82.95 124.945 437.86)'
        />
        <path
          d='M445.79 377.38h21.04v.11h-21.04z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-81.33 119.548 443.586)'
        />
        <path
          d='M106.32 111.36h-.11l1.45-21.09.11.01-1.45 21.08z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M452.26 387.9l-.61-.12 3.88-19.78a1.66 1.66 0 0 1 1.74-1.34l5.34.31v.62l-5.34-.31a1.05 1.05 0 0 0-1.09.84z'
          style={{
            fill: 'url(#s-3ed5450257-Z)',
          }}
          transform='translate(-351.37 -276.72)'
        />
        <path
          d='M437.35 373.27h24.01v.08h-24.01z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.96 -225.853 869.338)'
        />
        <path
          d='M433.96 373.24h24.47v.08h-24.47z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.58 -235.6 877.544)'
        />
        <path
          d='M86.97 102.64l-.04-.07 20.53-12.33.04.07-20.53 12.33zM86.28 102.52l-.04-.07 20.27-12.17.04.07-20.27 12.17zM85.3 102.64l-.04-.07 20.6-12.33.04.07-20.6 12.33z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M457.84 365.81h.08v3.27h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-86.86 136.054 414.674)'
        />
        <path
          d='M456.94 366.59h.08v2.79h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-79.7 115.546 440.108)'
        />
        <path
          d='M106.24 91.99l-2.55-.62.02-.08 2.55.63-.02.07z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M455.68 367.56h.08v2.35h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-68.96 78.58 486.192)'
        />
        <path
          d='M455.06 367.93h.08v2.35h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-68.46 76.069 488.969)'
        />
        <path
          d='M439.1 376.77h.08v4.01h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-86 115.394 428.146)'
        />
        <path
          d='M439.87 376.44h.08v3.47h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-84.68 112.344 432.622)'
        />
        <path
          d='M440.77 376.03h.08v3.21h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-81.67 105.02 442.553)'
        />
        <path
          d='M441.6 375.59h.08v3.11h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='matrix(.17 -.99 .99 .17 -355.9 472.19)'
        />
        <path
          d='M99.54 96.04l-3.04-.43.01-.07 3.04.43-.01.07zM100.44 95.5l-3.02-.43.02-.08 3.01.43-.01.08z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M442.57 375.02h.08v3.09h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-80.34 103.048 446.315)'
        />
        <path
          d='M443.38 374.61h.08v2.94h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78 96.86 454.667)'
        />
        <path
          d='M444.19 374.08h.08v3.04h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-79.6 105.34 449.754)'
        />
        <path
          d='M445.02 373.65h.08v2.91h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78 98.509 453.692)'
        />
        <path
          d='M95.84 98.27l-2.87-.57.01-.08 2.88.58-.02.07z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M446.64 372.62h.08v3.03h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-80.59 107.805 442.97)'
        />
        <path
          d='M453.9 368.21h.08v3.2h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-80.04 113.511 440.68)'
        />
        <path
          d='M104.34 93.13l-2.44-.71.02-.07 2.44.71-.02.07zM103.24 93.81l-2.76-.55.02-.07 2.76.54-.02.08z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M452.45 369.25h.08v2.77h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-79.21 109.61 444.601)'
        />
        <path
          d='M451.76 369.68h.08v2.8h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.13 105.682 449.168)'
        />
        <path
          d='M451.09 370.08h.08v2.79h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-77.77 103.879 450.958)'
        />
        <path
          d='M448.71 371.43h.08v2.94h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-79.64 107.115 445.251)'
        />
        <path
          d='M98.02 96.96l-2.84-.57.02-.08 2.83.58-.01.07z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M447.37 372.32h.08v2.76h-.08z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-75.78 93.959 461.096)'
        />
        <path
          d='M429.58 392.99h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -237.708 894.215)'
        />
        <path
          d='M429.61 392.41h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -237.667 893.639)'
        />
        <path
          d='M429.77 391.79h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -237.516 893.015)'
        />
        <path
          d='M429.95 391.25h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -237.33 892.479)'
        />
        <path
          d='M429.98 390.67h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -237.307 891.898)'
        />
        <path
          d='M430.13 390.05h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -237.155 891.274)'
        />
        <path
          d='M430.2 389.55h24.27v.11H430.2z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -237.098 890.78)'
        />
        <path
          d='M430.41 389.03h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -236.875 890.254)'
        />
        <path
          d='M430.44 388.45h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -236.852 889.673)'
        />
        <path
          d='M430.6 387.83h24.27v.11H430.6z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -236.682 889.055)'
        />
        <path
          d='M430.78 387.29h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -236.514 888.514)'
        />
        <path
          d='M430.81 386.7h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -236.473 887.937)'
        />
        <path
          d='M430.97 386.09h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -236.321 887.314)'
        />
        <path
          d='M431.03 385.59h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -236.264 886.82)'
        />
        <path
          d='M431.13 385.02h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -236.169 886.26)'
        />
        <path
          d='M431.16 384.44h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -236.123 885.665)'
        />
        <path
          d='M431.31 383.82h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -235.976 885.06)'
        />
        <path
          d='M431.49 383.28h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -235.785 884.505)'
        />
        <path
          d='M431.52 382.7h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -235.762 883.924)'
        />
        <path
          d='M431.68 382.08h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -235.615 883.318)'
        />
        <path
          d='M431.74 381.58h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -235.553 882.807)'
        />
        <path
          d='M431.92 380.91h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -235.373 882.152)'
        />
        <path
          d='M432.07 380.3h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -235.221 881.528)'
        />
        <path
          d='M432.26 379.75h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -235.035 880.992)'
        />
        <path
          d='M432.29 379.17h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -235.007 880.392)'
        />
        <path
          d='M432.44 378.56h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -234.842 879.792)'
        />
        <path
          d='M432.5 378.06h24.27v.11H432.5z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -234.78 879.28)'
        />
        <path
          d='M432.6 377.49h24.27v.11H432.6z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -234.685 878.72)'
        />
        <path
          d='M432.63 376.91h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.7 -234.91 879.672)'
        />
        <path
          d='M432.79 376.29h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -234.492 877.52)'
        />
        <path
          d='M432.97 375.75h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -234.324 876.978)'
        />
        <path
          d='M433 375.17h24.27v.11H433z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -234.283 876.402)'
        />
        <path
          d='M433.15 374.55h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -234.132 875.778)'
        />
        <path
          d='M433.21 374.05h24.27v.11h-24.27z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-30.72 -234.074 875.285)'
        />
        <path
          d='M423.7 389.37h20.58v.11H423.7z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 89.738 465.128)'
        />
        <path
          d='M424.87 388.64h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 90.91 464.408)'
        />
        <path
          d='M424.28 389.03h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 90.31 464.792)'
        />
        <path
          d='M425.38 388.36h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 91.415 464.129)'
        />
        <path
          d='M426.55 387.64h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 92.587 463.408)'
        />
        <path
          d='M425.96 388.02h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 91.998 463.791)'
        />
        <path
          d='M427.06 387.36h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.5 94.586 464.244)'
        />
        <path
          d='M428.23 386.64h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 94.269 462.403)'
        />
        <path
          d='M427.64 387.02h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 93.674 462.792)'
        />
        <path
          d='M428.75 386.36h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 94.784 462.122)'
        />
        <path
          d='M429.92 385.63h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 95.95 461.397)'
        />
        <path
          d='M429.32 386.02h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 95.356 461.786)'
        />
        <path
          d='M430.43 385.41h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 96.467 461.178)'
        />
        <path
          d='M431.6 384.69h20.58v.11H431.6z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 97.639 460.458)'
        />
        <path
          d='M431.01 385.07h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 97.038 460.842)'
        />
        <path
          d='M432.11 384.41h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 98.148 460.173)'
        />
        <path
          d='M433.28 383.68h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 99.32 459.452)'
        />
        <path
          d='M432.69 384.07h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 98.72 459.836)'
        />
        <path
          d='M433.8 383.42h20.58v.11H433.8z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 99.837 459.183)'
        />
        <path
          d='M434.97 382.69h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 101.01 458.463)'
        />
        <path
          d='M434.38 383.08h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 100.41 458.847)'
        />
        <path
          d='M435.48 382.41h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 101.52 458.178)'
        />
        <path
          d='M436.65 381.69h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 102.691 457.457)'
        />
        <path
          d='M436.06 382.07h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 102.09 457.841)'
        />
        <path
          d='M437.16 381.41h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 103.196 457.178)'
        />
        <path
          d='M438.33 380.69h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 104.368 456.458)'
        />
        <path
          d='M437.74 381.07h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 103.779 456.84)'
        />
        <path
          d='M438.85 380.41h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 104.884 456.177)'
        />
        <path
          d='M440.01 379.68h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 106.05 455.452)'
        />
        <path
          d='M439.42 380.07H460v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 105.455 455.841)'
        />
        <path
          d='M440.53 379.46h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 106.571 455.227)'
        />
        <path
          d='M441.7 378.74h20.58v.11H441.7z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 107.737 454.502)'
        />
        <path
          d='M441.11 379.12h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 107.143 454.89)'
        />
        <path
          d='M442.21 378.46h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 108.253 454.221)'
        />
        <path
          d='M442.79 378.12h20.58v.11h-20.58z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-78.75 108.824 453.885)'
        />
        <path
          d='M440.92 381a25.54 25.54 0 0 1-5.79-.59v-.1a26.28 26.28 0 0 0 6.25.57v.12zM440.87 380.45a23.72 23.72 0 0 1-5.49-.56v-.1a24.26 24.26 0 0 0 6 .55v.11zM441 382.2a28.3 28.3 0 0 1-6.06-.6v-.11a28.7 28.7 0 0 0 6.47.6v.11zM441 381.62a26.67 26.67 0 0 1-6-.62v-.1a27.79 27.79 0 0 0 6.36.59v.1zM440.89 383.25a29.2 29.2 0 0 1-6.13-.58v-.11a30 30 0 0 0 6.62.58v.11zM441 382.67a29.18 29.18 0 0 1-6.16-.61v-.11a29.5 29.5 0 0 0 6.56.61v.11zM440.94 384.41a32.34 32.34 0 0 1-6.47-.6v-.11a32.05 32.05 0 0 0 6.91.6v.11zM440.9 383.83a31 31 0 0 1-6.32-.58v-.11a31.76 31.76 0 0 0 6.8.58v.11zM441 385.58a34.69 34.69 0 0 1-6.74-.63v-.11a34.12 34.12 0 0 0 7.13.62v.11zM441 385a33.1 33.1 0 0 1-6.67-.67v-.11a33.43 33.43 0 0 0 7 .67v.11zM440.83 386.74a35.9 35.9 0 0 1-6.8-.58v-.11a36.83 36.83 0 0 0 7.35.58v.11zM441 386.16a35.08 35.08 0 0 1-6.86-.64v-.11a35.86 35.86 0 0 0 7.24.64v.1zM440.9 387.79a38.57 38.57 0 0 1-7.09-.6v-.11a39.13 39.13 0 0 0 7.57.6v.11zM440.85 387.21a37.13 37.13 0 0 1-6.93-.59v-.11a38 38 0 0 0 7.46.59v.11zM441.08 389a41.38 41.38 0 0 1-7.47-.73v-.11a40.07 40.07 0 0 0 7.77.73v.11zM440.91 388.37a38.92 38.92 0 0 1-7.21-.61v-.11a40.27 40.27 0 0 0 7.68.61v.11zM441.05 389.53a42.38 42.38 0 0 1-7.56-.7v-.11a41.52 41.52 0 0 0 7.89.7v.11zM441 390.7a44.2 44.2 0 0 1-7.72-.65v-.1a46.07 46.07 0 0 0 8.13.64v.1zM441.05 390.11a42.38 42.38 0 0 1-7.68-.71v-.1a43.39 43.39 0 0 0 8 .7v.11zM440.81 391.86a46.82 46.82 0 0 1-7.8-.59v-.11a47.73 47.73 0 0 0 8.37.59v.11zM440.77 391.28a44.83 44.83 0 0 1-7.62-.58v-.11a46.08 46.08 0 0 0 8.23.58v.11zM440.85 393a48.74 48.74 0 0 1-8.07-.61v-.1a50.41 50.41 0 0 0 8.6.6v.11zM440.83 392.44a48.22 48.22 0 0 1-7.93-.6v-.11a49.1 49.1 0 0 0 8.49.6v.11zM440.86 394.07a51.16 51.16 0 0 1-8.28-.62v-.11a50.64 50.64 0 0 0 8.8.62v.11zM440.77 393.49a49.27 49.27 0 0 1-8.08-.58v-.11a50.77 50.77 0 0 0 8.7.58v.11zM440.77 395.24a52.89 52.89 0 0 1-8.39-.59v-.1a55.55 55.55 0 0 0 9 .58v.1zM441 394.65a52.77 52.77 0 0 1-8.53-.71v-.11a52.87 52.87 0 0 0 8.9.71v.11zM440.72 396.4a56.78 56.78 0 0 1-8.6-.59v-.11a58.45 58.45 0 0 0 9.27.59v.11zM440.7 395.82a55 55 0 0 1-8.45-.58v-.11a56.83 56.83 0 0 0 9.14.58v.11zM440.76 397.56a60.25 60.25 0 0 1-8.87-.6v-.11a60.06 60.06 0 0 0 9.49.6v.11zM440.74 397a57.33 57.33 0 0 1-8.74-.6v-.1a59.8 59.8 0 0 0 9.38.59v.11zM440.81 398.61a63.43 63.43 0 0 1-9.12-.61v-.11a62.76 62.76 0 0 0 9.7.61v.11zM440.79 398a60.31 60.31 0 0 1-9-.61v-.11a61.1 61.1 0 0 0 9.58.61v.11zM440.71 399.78a64.54 64.54 0 0 1-9.26-.59v-.1a67.72 67.72 0 0 0 9.93.58v.1zM440.7 399.2a63.23 63.23 0 0 1-9.13-.59v-.1a65.35 65.35 0 0 0 9.82.57v.11z'
          style={{
            fill: '#fff',
          }}
          transform='translate(-351.37 -276.72)'
        />
        <path
          d='M80.81 123.43l-.11-.02 3.93-20.77.11.02-3.93 20.77zM81.7 123.43l-.11-.02 3.75-20.84.11.02-3.75 20.84zM88.71 123.98l-.11-.01.16-21.24h.11l-.16 21.25z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M428.84 389.94h21.2v.11h-21.2z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-89.4 123.528 429.093)'
        />
        <path
          d='M87.21 123.82h-.11l.44-21.1h.11l-.44 21.1zM84.57 123.67l-.11-.01 2.28-21.09.1.01-2.27 21.09z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M427.78 389.86h21v.11h-21z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-88.08 119.527 433.225)'
        />
        <path
          d='M425.87 389.72h21.11v.11h-21.11z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-82.95 104.256 450.163)'
        />
        <path
          d='M425.1 389.69h21.04v.11H425.1z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-81.33 98.857 455.884)'
        />
        <path
          d='M85.63 123.67l-.11-.01 1.45-21.08h.11l-1.45 21.09z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M431.42 400.23l-.61-.12 3.88-19.74a1.68 1.68 0 0 1 1.74-1.35l5.34.31v.62l-5.34-.31a1.05 1.05 0 0 0-1.09.85z'
          style={{
            fill: 'url(#s-3ed5450257-aa)',
          }}
          transform='translate(-351.37 -276.72)'
        />
        <path
          d='M441.9 402.08l-1-.4.1-22.08a1.53 1.53 0 0 1 .75-1.32l20.15-12.17a.4.4 0 0 1 .32 0l.75.22a.4.4 0 0 1 .28.39l-.93 23.24-.93-.06v-21.7a.39.39 0 0 0-.59-.34l-18.15 10.94a1.57 1.57 0 0 0-.75 1.33z'
          style={{
            fill: 'url(#s-3ed5450257-ab)',
          }}
          transform='translate(-351.37 -276.72)'
        />
        <path
          d='M442.12 402l-.29.28.07-22.1a1.58 1.58 0 0 1 .75-1.33l20-12.06a.39.39 0 0 1 .59.33v20.58a3.1 3.1 0 0 1-.92 2.2v-21.18a.39.39 0 0 0-.59-.33l-18.12 10.94a1.55 1.55 0 0 0-.75 1.33v19.54a2.51 2.51 0 0 1-.74 1.8z'
          style={{
            fill: 'url(#s-3ed5450257-ac)',
          }}
          transform='translate(-351.37 -276.72)'
        />
      </g>
      <g
        id='unihockeyRight'
      >
        <path
          d='M291.17 150.13l-50.84-3.29-4.08-32.28 44.26 2.64 10.66 32.93z'
          style={{
            fill: 'none',
            stroke: '#fff',
            strokeMiterlimit: '10',
          }}
        />
        <path
          d='M279.2 142.07l10.94.62v-1l-6.53-19.45-9.71.21v1l8.49.48 5.46 17.04-8.65.1v1z'
          style={{
            fill: 'url(#s-3ed5450257-ad)',
          }}
        />
        <path
          d='M279.21 141.07l10.93.62-6.53-19.45-10.16-.47.52.68 9.03.51 5.86 18.06-9.85-.56.2.61z'
          style={{
            fill: 'url(#s-3ed5450257-ae)',
          }}
        />
        <path
          d='M634.51 400c-1 0-2.07 0-3.28-.14v-.09a36.91 36.91 0 0 0 7-.08v.1a34 34 0 0 1-3.72.21zM634.46 399.43c-1 0-2 0-3.19-.13v-.1a33.31 33.31 0 0 0 6.73-.07v.1a34.43 34.43 0 0 1-3.54.2zM634.5 401c-1.07 0-2.17 0-3.37-.13v-.1a39.61 39.61 0 0 0 7.26-.08v.1a36 36 0 0 1-3.89.21zM634.5 400.48c-1 0-2.13 0-3.32-.13v-.1a38.24 38.24 0 0 0 7.13-.07v.09a35 35 0 0 1-3.81.21zM634.67 402c-1.11 0-2.28-.05-3.62-.15v-.1a40.68 40.68 0 0 0 7.43-.05v.1c-1.31.11-2.48.2-3.81.2zM634.5 401.43c-1.09 0-2.21 0-3.4-.13v-.1a39.92 39.92 0 0 0 7.37-.08v.1a37.06 37.06 0 0 1-3.97.21zM634.71 403c-1.19 0-2.42 0-3.75-.15v-.1a43.2 43.2 0 0 0 7.74 0v.1c-1.31.15-2.62.15-3.99.15zM634.82 402.51c-1.18 0-2.43-.05-3.81-.15v-.1a42.87 42.87 0 0 0 7.63 0v.1a37.35 37.35 0 0 1-3.82.15zM634.71 404.08c-1.25 0-2.53-.05-3.84-.14v-.1a48.13 48.13 0 0 0 8 0v.09c-1.32.07-2.71.15-4.16.15zM634.24 403.53c-1.1 0-2.2 0-3.33-.12v-.1a45 45 0 0 0 7.87-.11v.1a44.63 44.63 0 0 1-4.54.23zM635.09 405.16c-1.33 0-2.71-.05-4.31-.17v-.1a49.21 49.21 0 0 0 8.24 0v.1c-1.36.12-2.62.17-3.93.17zM634.71 404.61c-1.27 0-2.57-.05-3.89-.15v-.1a48.61 48.61 0 0 0 8.12-.05v.1c-1.31.13-2.74.2-4.23.2zM635.13 406.11c-1.4 0-2.85-.05-4.44-.17v-.1a53.46 53.46 0 0 0 8.49 0v.1c-1.34.12-2.67.17-4.05.17zM635.11 405.59c-1.35 0-2.77-.06-4.37-.17v-.1a51.78 51.78 0 0 0 8.36 0v.1c-1.35.11-2.64.17-3.99.17zM634.18 407.12c-1.12 0-2.31 0-3.58-.12v-.1a56.12 56.12 0 0 0 8.72-.11v.1c-1.4.11-3.14.23-5.14.23zM635.15 406.64c-1.43 0-2.91-.06-4.5-.17v-.1a53.73 53.73 0 0 0 8.61 0v.1c-1.34.11-2.7.17-4.11.17zM634.45 407.66c-1.31 0-2.6 0-3.89-.14v-.1a56 56 0 0 0 8.86-.07v.1c-1.7.14-3.35.21-4.97.21zM635.22 408.75c-1.56 0-3.17-.06-4.75-.17v-.1a63 63 0 0 0 9.12 0v.1c-1.35.11-2.83.17-4.37.17zM634.51 408.19c-1.35 0-2.69-.05-4-.14V408a57.43 57.43 0 0 0 9-.07v.1c-1.68.09-3.35.16-5 .16zM635.7 409.84c-1.67 0-3.39-.07-5.33-.21v-.1a65.69 65.69 0 0 0 9.38.07v.1c-1.36.09-2.69.14-4.05.14zM635.63 409.31c-1.6 0-3.26-.07-5.21-.21v-.1a62.09 62.09 0 0 0 9.22.07v.1c-1.38.09-2.64.14-4.01.14zM635.77 410.89c-1.74 0-3.54-.07-5.49-.21v-.1a67.72 67.72 0 0 0 9.63.07v.1c-1.35.09-2.72.14-4.14.14zM635.73 410.36c-1.7 0-3.46-.07-5.4-.2v-.1a67.38 67.38 0 0 0 9.5.07v.1c-1.35.09-2.71.13-4.1.13zM636 411.84c-1.67 0-3.38-.06-5.32-.2v-.1a65.55 65.55 0 0 0 9.37.07v.1c-1.35.09-2.68.13-4.05.13zM636.1 411.33c-1.8 0-3.73-.07-5.85-.22V411a71.39 71.39 0 0 0 9.74.1v.1c-1.25.09-2.53.13-3.89.13zM636.55 412.93c-1.73 0-3.59-.08-5.82-.23v-.1a66.17 66.17 0 0 0 9.46.11v.1c-1.19.08-2.39.12-3.64.12zM635.29 412.33c-1.51 0-3-.05-4.6-.17v-.1a64.63 64.63 0 0 0 9.44 0v.1c-1.74.11-3.31.17-4.84.17zM636.57 414c-1.68 0-3.36-.07-5.67-.24v-.1a66.32 66.32 0 0 0 9.49.13v.1c-1.39.11-2.61.11-3.82.11zM636.49 413.46c-1.64 0-3.28-.07-5.59-.23v-.1a66.32 66.32 0 0 0 9.39.12v.1c-1.42.07-2.61.11-3.8.11zM636 415.07c-1.56 0-3.21-.06-5.27-.2v-.1a69.84 69.84 0 0 0 9.78.06v.1c-1.57.07-2.98.14-4.51.14zM636.62 414.52c-1.74 0-3.49-.08-5.79-.24v-.1a66.85 66.85 0 0 0 9.64.12v.1c-1.39.08-2.61.12-3.85.12zM636.11 416c-1.62 0-3.34-.06-5.42-.21v-.1a73.33 73.33 0 0 0 10 .07v.1c-1.57.14-3.03.14-4.58.14zM636.08 415.5c-1.59 0-3.27-.06-5.35-.21v-.1a70 70 0 0 0 9.89.07v.1c-1.62.09-3.03.14-4.54.14zM636.68 417.11c-1.92 0-3.86-.08-6.08-.24v-.1a77.3 77.3 0 0 0 10.28.12v.1c-1.46.08-2.82.12-4.2.12zM636.55 416.58c-1.86 0-3.73-.08-5.91-.23v-.1a76.68 76.68 0 0 0 10.14.1v.1c-1.48.08-2.85.13-4.23.13z'
          style={{
            fill: '#fff',
          }}
          transform='translate(-351.37 -276.72)'
        />
        <path
          d='M288.67 141.31l-2.3-19.23.1-.01 2.3 19.23-.1.01z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M638.08 398.61h.1v19.56h-.1z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-5.8 -2269.182 3737.851)'
        />
        <path
          d='M280.18 140.87h-.1l.08-19.18h.1l-.08 19.18zM280.85 140.85h-.1l.08-19.08h.11l-.09 19.08zM281.58 140.98h-.1l.14-19.21h.1l-.14 19.21z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M635.54 398.57h.1v19.19h-.1z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-1.57 -9637.656 13092.155)'
        />
        <path
          d='M282.45 121.77h.1v19.28h-.1z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M636.25 398.59h.1v19.33h-.1z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-2.39 -6171.55 8692.577)'
        />
        <path
          d='M637.21 398.61h.1v19.48h-.1z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-4.12 -3385.307 5154.13)'
        />
        <path
          d='M634.66 398.49h.1v19.3h-.1z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-.81 -19116.238 25122.543)'
        />
        <path
          d='M628.07 381.35c-.7 0-1.44 0-2.25-.07v-.1A28.56 28.56 0 0 0 632 381v.1a26.52 26.52 0 0 1-3.93.25zM628.09 380.83c-.68 0-1.41 0-2.24-.07v-.1a26.22 26.22 0 0 0 5.95-.21v.1a25.58 25.58 0 0 1-3.71.28zM628 382.39c-.72 0-1.46 0-2.25-.07v-.1a31.33 31.33 0 0 0 6.43-.22v.1a28.71 28.71 0 0 1-4.18.29zM628 381.87c-.71 0-1.45 0-2.24-.07v-.1a30.25 30.25 0 0 0 6.32-.22v.1a27.64 27.64 0 0 1-4.08.29zM628.18 383.34c-.77 0-1.58 0-2.48-.07v-.1a32.73 32.73 0 0 0 6.57-.2v.1a31.79 31.79 0 0 1-4.09.27zM628 382.81c-.73 0-1.48 0-2.26-.07v-.1a32.12 32.12 0 0 0 6.51-.22v.1a31.27 31.27 0 0 1-4.25.29zM628.14 384.39c-.79 0-1.62 0-2.5-.08v-.1a34.86 34.86 0 0 0 6.86-.21v.1a32.84 32.84 0 0 1-4.36.29zM628.26 383.87c-.81 0-1.66 0-2.59-.08v-.1a34.25 34.25 0 0 0 6.74-.19v.1a31.68 31.68 0 0 1-4.15.27zM628.07 385.43c-.81 0-1.64 0-2.49-.08v-.1a37.16 37.16 0 0 0 7.08-.21v.1a35.52 35.52 0 0 1-4.59.29zM627.75 384.89c-.71 0-1.42 0-2.14-.06v-.1a36.13 36.13 0 0 0 7-.26v.09a36.68 36.68 0 0 1-4.86.33zM628.46 386.49c-.91 0-1.87 0-2.94-.1v-.1a38.66 38.66 0 0 0 7.29-.16v.1a37.94 37.94 0 0 1-4.35.26zM628.05 386c-.82 0-1.66 0-2.5-.08v-.1a39.2 39.2 0 0 0 7.19-.21v.09a35.09 35.09 0 0 1-4.69.3zM628.42 387.43c-.94 0-1.92 0-3-.09v-.1a43 43 0 0 0 7.52-.17v.1a40.24 40.24 0 0 1-4.52.26zM628.46 386.91c-.93 0-1.9 0-3-.09v-.1a40.71 40.71 0 0 0 7.4-.17v.1a38.93 38.93 0 0 1-4.4.26zM627.63 388.44c-.71 0-1.46 0-2.23-.06v-.1a44.46 44.46 0 0 0 7.72-.28v.1a47.51 47.51 0 0 1-5.49.34zM628.4 388c-.95 0-1.93 0-3-.09v-.1a44.29 44.29 0 0 0 7.63-.17v.1a41.49 41.49 0 0 1-4.63.26zM627.81 389c-.82 0-1.63 0-2.44-.07v-.1a45.24 45.24 0 0 0 7.84-.25v.1a48.08 48.08 0 0 1-5.4.32zM628.33 390c-1 0-2 0-3-.09v-.1a48.44 48.44 0 0 0 8.07-.18v.1a44.75 44.75 0 0 1-5.07.27zM627.83 389.49c-.84 0-1.67 0-2.49-.07v-.1a46.33 46.33 0 0 0 7.95-.24v.09a46.22 46.22 0 0 1-5.46.32zM628.82 391.1c-1.12 0-2.3 0-3.58-.11v-.1a51.56 51.56 0 0 0 8.31-.13v.1a46.77 46.77 0 0 1-4.73.24zM628.83 390.58c-1.1 0-2.25 0-3.56-.11v-.1a49.66 49.66 0 0 0 8.16-.13v.1a45.11 45.11 0 0 1-4.6.24zM628.8 392.14c-1.15 0-2.35 0-3.62-.11v-.1a53.13 53.13 0 0 0 8.53-.13v.1a49.34 49.34 0 0 1-4.91.24zM628.81 391.62c-1.14 0-2.32 0-3.6-.11v-.1a52.92 52.92 0 0 0 8.42-.13v.1a48 48 0 0 1-4.82.24zM628.81 393.08c-1.19 0-2.41 0-3.68-.11v-.1a55.65 55.65 0 0 0 8.73-.13v.1c-1.61.16-3.29.24-5.05.24zM629.1 392.57c-1.24 0-2.54 0-3.94-.12v-.1a55.27 55.27 0 0 0 8.63-.1v.1a46.77 46.77 0 0 1-4.69.22zM629.27 394.14c-1.33 0-2.73 0-4.21-.12v-.1a59.05 59.05 0 0 0 8.93-.09v.1q-2.14.21-4.72.21zM628.13 393.58c-1 0-2 0-3-.09v-.1a57.23 57.23 0 0 0 8.83-.2v.1c-2.02.19-3.96.29-5.83.29zM629.28 395.19c-1.33 0-2.72-.05-4.28-.13V395a63.36 63.36 0 0 0 9.19-.08v.1c-1.67.1-3.19.17-4.91.17zM629.27 394.67c-1.31 0-2.68-.05-4.24-.13v-.1a61.55 61.55 0 0 0 9.06-.08v.1c-1.66.14-3.19.21-4.82.21zM629.29 396.23c-1.38 0-2.81 0-4.35-.13v-.1a65.11 65.11 0 0 0 9.42-.08v.1c-1.68.14-3.36.21-5.07.21zM629.28 395.71c-1.35 0-2.76 0-4.31-.13v-.1a64.89 64.89 0 0 0 9.3-.08v.1c-1.67.14-3.27.21-4.99.21zM629.29 397.17c-1.42 0-2.88 0-4.41-.13v-.1a68 68 0 0 0 9.62-.08v.1c-1.67.14-3.4.21-5.21.21zM629.28 396.65c-1.39 0-2.83 0-4.37-.13v-.1a66.22 66.22 0 0 0 9.5-.08v.1c-1.66.14-3.35.21-5.13.21zM629.8 398.23c-1.56 0-3.22-.05-5-.14V398a74.12 74.12 0 0 0 9.84 0v.1c-1.45.07-3.08.13-4.84.13zM629.72 397.71c-1.52 0-3.13 0-4.87-.15v-.1a69.35 69.35 0 0 0 9.73 0v.1c-1.5.09-3.11.15-4.86.15z'
          style={{
            fill: '#fff',
          }}
          transform='translate(-351.37 -276.72)'
        />
        <path
          d='M632.76 380.05h.1v19.11h-.1z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-7.17 -1751.19 3055.4)'
        />
        <path
          d='M632.04 379.95h.1v19.31h-.1z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-6.26 -2074.217 3463.782)'
        />
        <path
          d='M274.71 122.26l-.02-19.11h.1l.02 19.11h-.1z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M626.75 379.97h.1v18.95h-.1z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-.13 -121488.883 155125.056)'
        />
        <path
          d='M627.52 379.97h.1v18.94h-.1z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-.31 -50702.233 65187.737)'
        />
        <path
          d='M278.82 122.18l-.81-18.94.1-.01.81 18.95h-.1z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M628.32 379.97h.1v18.99h-.1z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-.75 -20686.745 27093.1)'
        />
        <path
          d='M630.41 379.96h.1v19.1h-.1z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-3.2 -4498.6 6540.77)'
        />
        <path
          d='M631.27 379.96h.1v19.24h-.1z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-4.75 -2880.637 4486.952)'
        />
        <path
          d='M629.06 379.87h.1v19.09h-.1z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-1.41 -10791.75 14527.871)'
        />
        <path
          d='M634.38 399.32l-2.19-18.14c-.07-.78-.94-.92-1.66-.9l-6-.2v-.57l6 .2c1.89 0 2.19 1 2.23 1.41l2.24 18.13z'
          style={{
            fill: 'url(#s-3ed5450257-af)',
          }}
          transform='translate(-351.37 -276.72)'
        />
        <path
          d='M635.09 400.65l-2.19-18.14a1.31 1.31 0 0 0-1.25-1.18l-6-.2V381l6 .2a1.4 1.4 0 0 1 1.35 1.3l2.2 18.13z'
          style={{
            fill: '#fff',
          }}
          transform='translate(-351.37 -276.72)'
        />
        <path
          d='M635.55 401.93l-2.19-18.13a1.33 1.33 0 0 0-1.24-1.19l-6-.19v-.1l6 .19a1.42 1.42 0 0 1 1.34 1.28l2.19 18.13z'
          style={{
            fill: '#fff',
          }}
          transform='translate(-351.37 -276.72)'
        />
        <path
          d='M636.05 403.54l-2.19-18.13a1.31 1.31 0 0 0-1.24-1.19l-6-.19v-.1l6 .19a1.42 1.42 0 0 1 1.38 1.28l2.19 18.13z'
          style={{
            fill: '#fff',
          }}
          transform='translate(-351.37 -276.72)'
        />
        <path
          d='M636.51 404.68l-2.2-18.13a1.3 1.3 0 0 0-1.24-1.18l-6-.2v-.1l6 .2a1.4 1.4 0 0 1 1.33 1.27l2.2 18.13z'
          style={{
            fill: '#fff',
          }}
          transform='translate(-351.37 -276.72)'
        />
        <path
          d='M637 406l-2.19-18.13a1.31 1.31 0 0 0-1.25-1.18l-6-.2v-.1l6 .2a1.4 1.4 0 0 1 1.33 1.27l2.2 18.13z'
          style={{
            fill: '#fff',
          }}
          transform='translate(-351.37 -276.72)'
        />
        <path
          d='M637.43 407.37l-2.19-18.13a1.31 1.31 0 0 0-1.24-1.19l-6-.2v-.1l6 .2a1.41 1.41 0 0 1 1.34 1.28l2.19 18.13z'
          style={{
            fill: '#fff',
          }}
          transform='translate(-351.37 -276.72)'
        />
        <path
          d='M637.94 409l-2.19-18.14a1.31 1.31 0 0 0-1.24-1.18l-6-.2v-.1l6 .2a1.42 1.42 0 0 1 1.34 1.27L638 409z'
          style={{
            fill: '#fff',
          }}
          transform='translate(-351.37 -276.72)'
        />
        <path
          d='M638.42 410.4l-2.19-18.13a1.3 1.3 0 0 0-1.24-1.18l-6-.2v-.1l6 .2a1.4 1.4 0 0 1 1.33 1.27l2.19 18.13z'
          style={{
            fill: '#fff',
          }}
          transform='translate(-351.37 -276.72)'
        />
        <path
          d='M638.9 411.84l-2.2-18.13a1.3 1.3 0 0 0-1.24-1.19l-6-.19v-.1l6 .19a1.42 1.42 0 0 1 1.33 1.28l2.2 18.13z'
          style={{
            fill: '#fff',
          }}
          transform='translate(-351.37 -276.72)'
        />
        <path
          d='M639.38 413.28l-2.2-18.14a1.3 1.3 0 0 0-1.24-1.18l-6-.2v-.1l6 .2a1.4 1.4 0 0 1 1.33 1.27l2.2 18.13z'
          style={{
            fill: '#fff',
          }}
          transform='translate(-351.37 -276.72)'
        />
        <path
          d='M639.88 415l-2.19-18.14a1.3 1.3 0 0 0-1.24-1.18l-6-.2v-.1l6 .2a1.4 1.4 0 0 1 1.34 1.27L640 415z'
          style={{
            fill: '#fff',
          }}
          transform='translate(-351.37 -276.72)'
        />
        <path
          d='M640.35 416.35l-2.19-18.14a1.3 1.3 0 0 0-1.24-1.18l-6-.2v-.1l6 .2a1.41 1.41 0 0 1 1.34 1.27l2.19 18.14z'
          style={{
            fill: '#fff',
          }}
          transform='translate(-351.37 -276.72)'
        />
        <path
          d='M640.62 418l-2.19-18.13a1.08 1.08 0 0 0-1-1l-6.38-.2v-.57l6.39.2a1.64 1.64 0 0 1 1.56 1.49l2.19 18.12z'
          style={{
            fill: 'url(#s-3ed5450257-ag)',
          }}
          transform='translate(-351.37 -276.72)'
        />
        <path
          d='M629.02 379.33h.1v19.33h-.1z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-17.86 -427.288 1368.63)'
        />
        <path
          d='M630.17 379.44h.1v19.37h-.1z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-17.47 -445.984 1394.17)'
        />
        <path
          d='M282.78 121.78l-5.7-18.56.09-.03 5.71 18.56-.1.03zM284.08 121.78l-6.09-18.61.09-.04 6.09 18.62-.09.03zM285.14 121.78l-6.31-18.52.1-.03 6.3 18.52-.09.03z'
          style={{
            fill: '#fff',
          }}
        />
        <path
          d='M634.47 379.58h.1v19.52h-.1z'
          style={{
            fill: '#fff',
          }}
          transform='rotate(-18.69 -381.795 1318.613)'
        />
        <path
          d='M630.77 419a.57.57 0 0 1-.57-.57V398.3l-4.71-14.73V400a.57.57 0 0 1-.57.57.56.56 0 0 1-.57-.57v-20.08a.57.57 0 0 1 1.11-.17l5.83 18.2a.53.53 0 0 1 .05.25v20.21a.56.56 0 0 1-.57.59z'
          style={{
            fill: 'url(#s-3ed5450257-ah)',
          }}
          transform='translate(-351.37 -276.72)'
        />
      </g>
    </g>
  </Fragment>
)

const defaultProps = {
  children,
  viewBox,
  fillColor: null,
  fillColorRule: '&&& path, &&& use, &&& g',
  size: null
}

const propTypes = {
  fillColor: PropTypes.string,
  fillColorRule: PropTypes.string,
  viewBox: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  size: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      height: PropTypes.number.isRequired,
      width: PropTypes.number.isRequired
    })
  ]),
  sizes: (props, name, componentName) => {
    const prop = props[name]
    if (typeof prop !== 'object') { return }
    for (let key in prop) {
      if (!prop[key] || typeof prop[key].width !== 'number' || typeof prop[key].height !== 'number') {
        return new Error(
          'Invalid prop `' + name + '` supplied to `' + componentName + '`. Validation failed.'
        )
      }
    }
  }
}

export default Object.assign(Image, {
  getDimensions,
  getCss,
  defaultProps,
  propTypes,
  displayName: '10x8'
})
